.icon {
  display: inline-block;
  overflow: visible;
  box-sizing: content-box;
  height: 1em;
  vertical-align: -0.125em;
}
